const OPEN_STATE = {
  0: false,
  1: true
}
const MEDIA_TYPE = {
  0: '全部',
  1: '定投',
  2: '屏蔽'
}

export default {
  OPEN_STATE,
  MEDIA_TYPE
}



// WEBPACK FOOTER //
// ./src/common/js/Enums.js